"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortCategories = exports.sortLabelValues = void 0;
const LabelCategories_1 = require("./shared/LabelCategories");
function sortLabelValues(a, b) {
    const isSpecialCategoryA = (0, LabelCategories_1.isBuiltInLabelCategory)(a.category);
    const isSpecialCategoryB = (0, LabelCategories_1.isBuiltInLabelCategory)(b.category);
    if (isSpecialCategoryA && !isSpecialCategoryB) {
        return -1;
    }
    else if (!isSpecialCategoryA && isSpecialCategoryB) {
        return 1;
    }
    else if (isSpecialCategoryA && isSpecialCategoryB) {
        const aCategoryIndex = LabelCategories_1.BuiltInLabelCategories.indexOf(a.category.toLowerCase());
        const bCategoryIndex = LabelCategories_1.BuiltInLabelCategories.indexOf(b.category.toLowerCase());
        if (aCategoryIndex !== bCategoryIndex) {
            return aCategoryIndex - bCategoryIndex;
        }
        else {
            if (a.builtIn && !b.builtIn) {
                return -1;
            }
            else if (!a.builtIn && b.builtIn) {
                return 1;
            }
            else {
                return caseInsensitiveCompare(a.value, b.value);
            }
        }
    }
    else {
        const categoryComparison = a.category.localeCompare(b.category);
        if (categoryComparison !== 0) {
            return categoryComparison;
        }
        else {
            return caseInsensitiveCompare(a.value, b.value);
        }
    }
}
exports.sortLabelValues = sortLabelValues;
function sortCategories(categories) {
    return [...categories].sort(customCategorySort);
}
exports.sortCategories = sortCategories;
function customCategorySort(a, b) {
    const aLower = a.toLowerCase();
    const bLower = b.toLowerCase();
    if ((0, LabelCategories_1.isBuiltInLabelCategory)(aLower) && (0, LabelCategories_1.isBuiltInLabelCategory)(bLower)) {
        return LabelCategories_1.BuiltInLabelCategories.indexOf(aLower) - LabelCategories_1.BuiltInLabelCategories.indexOf(bLower);
    }
    else if ((0, LabelCategories_1.isBuiltInLabelCategory)(aLower)) {
        return -1;
    }
    else if ((0, LabelCategories_1.isBuiltInLabelCategory)(bLower)) {
        return 1;
    }
    else {
        return caseInsensitiveCompare(a, b);
    }
}
function caseInsensitiveCompare(a, b) {
    const result = a.localeCompare(b, undefined, { sensitivity: 'base' });
    if (result !== 0) {
        return result;
    }
    if (a < b) {
        return -1;
    }
    else if (a > b) {
        return 1;
    }
    else {
        return 0;
    }
}
//# sourceMappingURL=LabelValueSorting.js.map